import { Users, Wrench } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";

interface Crew {
  id: string;
  name: string;
  status: string;
  specialties?: string[];
  members?: any[];
}

interface CrewListProps {
  crews: Crew[];
}

const CREW_COLORS = [
  "bg-primary/20 border-primary",
  "bg-secondary/20 border-secondary",
  "bg-accent/20 border-accent",
  "bg-warning/20 border-warning",
  "bg-success/20 border-success",
];

export function CrewList({ crews }: CrewListProps) {
  if (crews.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <Users className="w-12 h-12 text-muted-foreground mb-3" />
        <p className="text-sm text-muted-foreground">No crews available</p>
        <p className="text-xs text-muted-foreground mt-1">Create crews in Crew Management</p>
      </div>
    );
  }

  return (
    <ScrollArea className="h-[calc(100vh-300px)]">
      <div className="space-y-3 pr-4">
        {crews.map((crew, index) => {
          const colorClass = CREW_COLORS[index % CREW_COLORS.length];
          return (
            <div 
              key={crew.id}
              className={`premium-card p-4 border-l-4 ${colorClass}`}
            >
              <div className="flex items-start justify-between mb-2">
                <h4 className="font-semibold">{crew.name}</h4>
                <Badge variant="outline" className="text-xs">
                  {crew.status}
                </Badge>
              </div>
              {crew.specialties && crew.specialties.length > 0 && (
                <div className="flex items-center gap-1 text-xs text-muted-foreground">
                  <Wrench className="w-3 h-3" />
                  <span>{crew.specialties.slice(0, 2).join(", ")}</span>
                </div>
              )}
              {crew.members && (
                <p className="text-xs text-muted-foreground mt-1">
                  {Array.isArray(crew.members) ? crew.members.length : 0} members
                </p>
              )}
            </div>
          );
        })}
      </div>
    </ScrollArea>
  );
}
